import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})

/* Types */
export const SET_LEGAL_REPS = 'SET_LEGAL_REPS'
//se elimina variable
/* Reducer */
export default (state = initialState, action) => {
	//se elimina un case inecesario
	switch (action.type) {
		case SET_LEGAL_REPS:
			return new Immutable.Map(action.dataObj)
		default:
			return state;
	}
};

/* Action Creators */

export const getLegalRepresentatives = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getLegalData',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));
			let dataObj = response.data.representantesLegales
			//se cambia el valor de dataObj en la comparacion
			if (dataObj === null)
				dataObj = { representanteLegal: [] }

			dispatch({type: SET_LEGAL_REPS, dataObj })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setLegalRepresentative = (form) => {

	form = {
		"idDonataria" : form.idDonataria,
		"representantesLegales" : {
			"representanteLegal" : [ {
				"idRepresetanteLegal": form.idRepresetanteLegal,
				"nombre" : form.name,
				"apellidoPaterno" : form.paternalSurname + "-" + form.mail,
				"apellidoMaterno" : form.maternalSurname,
				"email": form.mail,
				"tipoPoder" : form.powerType,
				"numeroEscritura" : form.deedNumber,
				"fechaEscritura" : form.deedDate ? form.deedDate.slice(0,10) : undefined,
				"notario" : {
					"nombre" : form.notaryName,
					"apellidoPaterno" : form.notaryPaternalSurname,
					"apellidoMaterno" : form.notaryMaternalSurname
				},
				"numeroNotaria" : form.notaryOfficeNum,
				"estado" : form.state,
				"folioRPP" : form.RPPFolio,
				"fechaFolioRPP" : form.folioDate ? form.folioDate.slice(0,10) : undefined,
				"inicioVigencia" : form.inicioVigenciaDate ? form.inicioVigenciaDate.slice(0,10) : undefined,
				"finVigencia" : form.finVigenciaDate ? form.finVigenciaDate.slice(0,10) : undefined
			} ]
		}
	}

	return (dispatch) => {

		dispatch(isLoading(true));
		//se elimina dispatch con variable de persistencia y se retorna el response
		return new ClientHttpRequest({
			service: 'api/setLegalData',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false));
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const deleteLegalRepresentative = (idDonataria, idLegalData) => {

	return (dispatch) => {

		dispatch(isLoading(true));
		//se elimina dispatch con variable de persistencia y se retorna el response
		return new ClientHttpRequest({
			service: 'api/deleteLegalData',
			method: "POST",
			data: { idDonataria, id: [idLegalData] },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then( (response) => {
			dispatch(isLoading(false));
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearLegalRepresentative = () => {

	return (dispatch) => {
		dispatch({ type: SET_LEGAL_REPS, Obj: [] })
	}
}

export const setUpdateMailLegal = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setUpdateMailLegal',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Register/LegalRepresentation.js